import {AuctionRoundType} from "domain-models"
import React from "react"
import Trans from '../../../components/Trans'

type AuctionTypeProps = {
  auctionType: AuctionRoundType
}

class AuctionType extends React.Component<AuctionTypeProps> {
  render() {
    return this.props.auctionType === 0 ? (
      <div className="border-t border-orange-500 text-orange-100 leading-relaxed uppercase text-xs w-full flex justify-center select-none cursor-default" title="Gib einen realistischen Preis ab, du kannst diesen nur ein mal Ändern.">
        <span className="bg-orange-500 rounded-b px-2"><Trans>Mein Angebot</Trans></span>
      </div>
    ) : this.props.auctionType === 1 ?
      (
        <div className="border-t border-blue-500 text-blue-100 leading-relaxed uppercase text-xs w-full flex justify-center select-none cursor-default" title="Eine normale Auktion. Mit Bietagenten für den Höchstbietenden.">
          <span className="bg-blue-500 rounded-b px-2"><Trans>Auktion</Trans></span>
        </div>
      )
      : this.props.auctionType === 2 ?
        (
          <div className="border-t border-purple-500 text-purple-100 leading-relaxed uppercase text-xs w-full flex justify-center select-none cursor-default" title="Kaufen Sie dieses Fahrzeug sofort.">
            <span className="bg-purple-500 rounded-b px-2"><Trans>Sofort Kauf</Trans></span>
          </div>
        )
        : null
  }
}

export default AuctionType
